import { render, staticRenderFns } from "./report-details.vue?vue&type=template&id=38241e42&scoped=true&"
import script from "./report-details.vue?vue&type=script&lang=js&"
export * from "./report-details.vue?vue&type=script&lang=js&"
import style0 from "./report-details.vue?vue&type=style&index=0&id=38241e42&lang=scss&scoped=true&"
import style1 from "./report-details.vue?vue&type=style&index=1&id=38241e42&scoped=true&lang=scss&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38241e42",
  null
  
)

export default component.exports